import http from "./httpService";

const apiEndpoint = "/client/employees";

// function employeeUrl(id) {
//   return `${apiEndpoint}/${id}`;
// }

export function getEmployees(params = {}) {
  return http.get(apiEndpoint, { params });
}

// export function getEmployee(employeeId) {
//   return http.get(employeeUrl(employeeId));
// }

// export function saveEmployee(employee) {
//   if (employee.id) {
//     const body = { ...employee };
//     delete body.id;
//     return http.put(employeeUrl(employee.id), body);
//   }

//   return http.post(apiEndpoint, employee);
// }

// export function deleteEmployee(employeeId) {
//   return http.delete(employeeUrl(employeeId));
// }
